import { ref } from 'vue';

// 全局变量
const isShowScanGift = ref(false);

export function useIsShowScanGift() {
  function updateShowState(nVal: boolean) {
    isShowScanGift.value = nVal;
  }

  return {
    /** 扫码券礼包当前的展示状态 */
    isShowScanGift,
    /** 更新当前扫码券礼包的展示状态 */
    updateShowState,
  };
}
